<template>
  <div class="accordion-item" @mouseenter="$emit('enter')" @mouseleave="$emit('leave')">
    <h2 class="accordion-header" :id="`jumbotron-configuration-${id}`">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
        :data-bs-target="`#jumbotron-configuration-${id}-body`" aria-expanded="false" data-jumbotron="true"
        :aria-controls="`#jumbotron-configuration-${id}-body`">
        <slot name="header" />
      </button>
    </h2>
    <div :id="`jumbotron-configuration-${id}-body`" class="accordion-collapse collapse"
      :aria-labelledby="`jumbotron-configuration-${id}`" data-bs-parent="#jumbotron-configurations" data-exclude="true">
      <div class="accordion-body" :class="{ 'p-0': noMargin, 'p-4': !noMargin }">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "JumbotronConfigTab",
  emits: ["enter", "leave"],
  props: {
    id: {
      type: String,
      required: true,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped>
.accordion-header {
  border-radius: inherit !important;
}

.accordion-button {
  border-radius: inherit !important;
}
</style>
